import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ExperienceAdapter, ExperienceOverview } from '@shared/models';
import { trackElement } from '@shared/utils';

@Component({
  selector: 'mojo-candidate-resume-experience',
  templateUrl: './candidate-resume-experience.component.html',
  styleUrls: ['./candidate-resume-experience.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateResumeExperienceComponent {
  @Input()
  overview: ExperienceOverview;

  @Input()
  experiences: ExperienceAdapter[];

  @Input()
  keywords: string[];

  trackElement = trackElement;
}
